

import { useMutation } from '@tanstack/react-query';
import { oracleRepository } from '../../repositories/oracle-repository';
import { PatchOpportunityParams } from '../../interfaces/opportunity';

interface Props {
  options: { optyNumber: string };
  data: PatchOpportunityParams;
}

export const usePatchEnqueueOpportunity = () => useMutation(
    async ({ data, options }: Props) =>
      await oracleRepository.patchEnqueueOpportunity(data, options),
  );
